import {VueRouter} from 'vue-router/types/router';
import RouteNames from '@/router/RouteNames';

export default class Routing {

    private router: VueRouter;

    constructor(router: VueRouter) {
        this.router = router;
    }

    public async signIn(): Promise<void> {
        await this.router.push({name: RouteNames.signIn});
    }

    public async home(): Promise<void> {
        await this.router.push({name: RouteNames.home});
    }

    public async aclAccounts(): Promise<void> {
        await this.router.push({name: RouteNames.aclAccounts});
    }
}